import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';
import {FORCE_CENTRALIZATION, FORCE_TRANSPARENT_BACKGROUND} from '../../css-classes';
import {hexToRgba} from "../../../../themes/hex-to-rgba";

const DefaultBox = styled.div<{transparentBackgroundOpacity: number; isHidden: boolean}>`
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  
    display: ${props => props.isHidden ? "none" : "flex"};
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    
    background-color: ${props => hexToRgba(props.theme.colors.background, 0.85)};
    ${CssRule.For.embededHybrid.build()} & {
        top: env(safe-area-inset-top);
        height: calc(100% -  env(safe-area-inset-top));
    }


    &.${FORCE_TRANSPARENT_BACKGROUND} {
        background-color: rgba(0, 0, 0, ${props => props.transparentBackgroundOpacity});
    }
`;

export const PcBox = styled(DefaultBox)`
    justify-content: center;
`;

export const MobileBox = styled(DefaultBox)`

    justify-content: flex-start;

    &.${FORCE_CENTRALIZATION} {
        align-items: center;
        justify-content: center;
    }

    ${CssRule.For.mobile.tablet.build()} & {
        justify-content: center;
    }

    ${CssRule.For.mobile.iPhoneVer10.build()} & {
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
    }
`;

export const DialogOverlayDefaultBox = styledByDevice(PcBox, MobileBox);